module.exports = __webpack_public_path__ + "static/media/customer.e4820412.svg";